import { Component, OnInit } from "@angular/core";
import { NgbActiveModal, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { environment } from "src/environments/environment";

@Component({
  standalone: false,
  templateUrl: "./plan-assignment-modal.component.html",
  styleUrls: ["../../../../styles.scss"],
})
export class PlanAssignmentModalComponent implements OnInit {
  minDate: NgbDateStruct;
  startDate: Date = new Date();
  hasPurpose = false;
  constructor(public activeModal: NgbActiveModal, private notificationService: ToastrService) { }

  ngOnInit() {
    var dateNow: Date = new Date();
    this.startDate.setDate(dateNow.getDate() + environment.neededByDateDelayDates);
    this.minDate = {
      year: this.startDate.getFullYear(),
      month: this.startDate.getMonth() + 1, // getMonth returns 0-11
      day: this.startDate.getDate(),
    };
  }

  submit(): void {
    if (!this.startDate) {
      this.notificationService.warning(`Please select a date.`);
      return;
    } else {
      try {
        this.activeModal.close({
          startDate: this.startDate,
        });
      } catch (e) {
        this.notificationService.error(e);
      }
    }
  }
}
